import React from 'react';

/**
 * SettingsUsers - User management tab component
 * Contains: user list (table/cards), search, view/edit functionality
 */
const SettingsUsers = ({
  users,
  userSearch,
  onUserSearchChange,
  userViewMode,
  onToggleUserViewMode,
  onViewUser,
  onEditUser
}) => {
  const filteredUsers = users.filter(u =>
    u.username?.toLowerCase().includes(userSearch.toLowerCase()) ||
    u.email?.toLowerCase().includes(userSearch.toLowerCase())
  );

  return (
    <div className="settings-section">
      <div className="section-header">
        <div className="section-header-left">
          <h2>Users</h2>
          <span className="item-count">{filteredUsers.length} users</span>
        </div>
      </div>

      <div className="section-controls">
        <div className="view-toggle">
          <button
            className={`view-toggle-btn ${userViewMode === 'table' ? 'active' : ''}`}
            onClick={() => onToggleUserViewMode('table')}
            title="Table View"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <rect x="1" y="3" width="14" height="2" />
              <rect x="1" y="7" width="14" height="2" />
              <rect x="1" y="11" width="14" height="2" />
            </svg>
          </button>
          <button
            className={`view-toggle-btn ${userViewMode === 'cards' ? 'active' : ''}`}
            onClick={() => onToggleUserViewMode('cards')}
            title="Card View"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <rect x="1" y="1" width="6" height="6" />
              <rect x="9" y="1" width="6" height="6" />
              <rect x="1" y="9" width="6" height="6" />
              <rect x="9" y="9" width="6" height="6" />
            </svg>
          </button>
        </div>
        <div className="search-container">
          <div className="search-box">
            <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="M21 21l-4.35-4.35"/>
            </svg>
            <input
              type="text"
              placeholder="Search users..."
              value={userSearch}
              onChange={(e) => onUserSearchChange(e.target.value)}
            />
          </div>
        </div>
      </div>

      {filteredUsers.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">👥</div>
          <p className="empty-text">No users found</p>
          <p className="empty-subtext">
            {userSearch ? 'Try a different search term' : 'Add users to get started'}
          </p>
        </div>
      ) : userViewMode === 'table' ? (
        <div className="users-table-container">
          <table className="users-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Email</th>
                <th>Role</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((u) => (
                <tr key={u.id}>
                  <td className="username">{u.username}</td>
                  <td>{u.email || '-'}</td>
                  <td>
                    <span className={`role-badge ${u.role}`}>{u.role}</span>
                  </td>
                  <td className="actions-cell">
                    <button className="action-btn view" onClick={() => onViewUser(u)}>
                      View
                    </button>
                    <button className="action-btn edit" onClick={() => onEditUser(u)}>
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="users-cards-container">
          {filteredUsers.map((u) => (
            <div key={u.id} className="user-card">
              <div className="user-card-header">
                <span className="user-avatar">
                  {u.username?.charAt(0).toUpperCase()}
                </span>
                <span className={`role-badge ${u.role}`}>{u.role}</span>
              </div>
              <div className="user-card-body">
                <h3 className="user-card-name">{u.username}</h3>
                <p className="user-card-email">{u.email || 'No email'}</p>
              </div>
              <div className="user-card-footer">
                <button className="card-action-btn view" onClick={() => onViewUser(u)}>
                  View
                </button>
                <button className="card-action-btn edit" onClick={() => onEditUser(u)}>
                  Edit
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SettingsUsers;
